import { useState, useEffect } from 'react'
import { Flex, Box, Text, Heading, Card } from 'rebass/styled-components'
import { IProperties } from '../../../builder/types';

interface IFillingLabelProps {
  properties: IProperties,
}

export const FillingLabel: React.FC<IFillingLabelProps> = ({ properties }) => {
  return (
    <>
      <Text fontWeight={500}>{`${((properties || {}).params || {}).question || 'Section'}`}</Text>
    </>);
}